import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';

/** ダイアログのViewModel */
export type NotAddedDeviceViewModel = {
  matp: string[];
  qualcomm: string[];
};

@Component({
  selector: 'app-device-notadded-list-dialog',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatFormFieldModule,
    CommonModule,
    MatInputModule,
    MatTooltipModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
  ],
  templateUrl: './device-notadded-list-dialog.component.html',
  styleUrl: './device-notadded-list-dialog.component.scss',
})
export class DeviceNotaddedListDialogComponent {
  public matpDeviceList: string[] = [];
  public qualcommDeviceList: string[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) options: NotAddedDeviceViewModel) {
    this.matpDeviceList = options.matp;
    this.qualcommDeviceList = options.qualcomm;
  }
}
